import React from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as Api from 'src/api'
import { useAuthenticatedHeaders } from 'src/hooks/auth/app'
import { authObservableValue, refreshTokenStorage } from 'src/hooks/auth/refreshTokenStorage'
import { useLocale } from 'src/hooks/locale/locale'
import { useTranslatable } from 'src/hooks/locale/utils'

export default function useEmulateUser() {
  const t = useTranslatable()
  const headers = useAuthenticatedHeaders()
  const navigate = useNavigate()
  const locale = useLocale()

  return React.useCallback(
    async ({ userId }: { userId: string }): Promise<void> => {
      try {
        const authObject = await Api.getEmulateUser({
          headers,
          args: {
            userId,
          },
          body: {
            clientId: '1',
            grantType: 'emulate',
          },
        })

        const user = await Api.getAuthUser({
          headers: {
            'Accept-Language': locale,
            Authorization: Api.getAuthorization(authObject),
          },
        })

        const profile = user.profiles[0]!

        refreshTokenStorage.setValue({ authObject, profileId: profile.id })

        authObservableValue.setValue({
          state: 'Authenticated',
          user,
          profile,
        })
        navigate(`/${locale}`, {
          replace: true,
        })
      } catch (error) {
        console.error('error', error)
        toast.error(t('error:an_error_occurred'))
      }
    },
    [headers, locale, navigate, t]
  )
}
